<ng-container>
    <h1 mat-dialog-title>
        <span>Feedback</span>
        <div class="pull-right close" (click)="closeContainer()">&#10005;</div>
    </h1>
</ng-container>

<div mat-dialog-content class="orderFeedback">
    <div class="order-info-section">
        <div style="display: flex; justify-content: space-between">
            <p class="order-list-heading">Your latest order</p>
        </div>

        <div class="feedback-item-details">
            @for (item of orderItemsToShow; track item) {
                <div class="product-details">
                    <div style="display: flex">
                        @if (!item.veg) {
                            <img src="{{ DEPLOY_URL }}/assets/images/non-veg.svg" class="item-icon" />
                        }
                        @if (item.veg) {
                            <img src="{{ DEPLOY_URL }}/assets/images/veg.svg" class="item-icon" />
                        }
                        <div style="display: flex; flex-direction: column; margin-left: 10px">
                            <span class="text-style1">
                                {{ item.name }}
                            </span>
                        </div>
                    </div>
                    <div class="text-style1 flex-end" style="white-space: nowrap">x {{ item.quantity }}</div>
                    <div class="text-style1 flex-end">{{ item.cost | rupee }}</div>
                </div>
            }
            <div class="view-more" (click)="openOrderDetailsModal()">
                <span style="text-decoration: underline">View more </span>
                <span class="arrow"></span>
            </div>
        </div>

        @if (order.order_status.status !== 'cancelled') {
            <div class="savings-container">
                @if (order.order_details.total_saving_amount) {
                    <div class="center1">
                        <img src="{{ DEPLOY_URL }}/assets/icons/checkmark_black.svg" width="12" height="12" />
                        <span class="content">
                            You’ve saved&nbsp;
                            <span style="color: var(--tertiary-color)">₹{{ order.order_details.total_saving_amount | abs }}</span
                            >&nbsp;on this order</span
                        >
                    </div>
                }
                @if (PCDCSavingstext) {
                    <div class="center1">
                        <img src="{{ DEPLOY_URL }}/assets/icons/checkmark_black.svg" width="12" height="12" />
                        <div class="content">
                            <span style="color: var(--tertiary-color)">Zero</span>&nbsp; <span>{{ PCDCSavingstext }}</span
                            >&nbsp;
                        </div>
                    </div>
                }
            </div>
        }
    </div>

    <delivery-support [order]="order" [wrapperClass]="'feedback'"></delivery-support>

    <hr class="feedback-seperator" />

    <form class="order-feedback-wrapper">
        <div class="rating-section">
            <p class="rating-heading">Please rate your experience</p>

            <bar-rating
                [(rate)]="this.feedbackFormData.food_rating"
                [max]="5"
                (rateChange)="changeRating()"
                [theme]="themeClass"></bar-rating>
            <p class="rating-label">Food</p>

            <bar-rating
                [(rate)]="this.feedbackFormData.delivery_rating"
                [max]="5"
                (rateChange)="changeRating()"
                [theme]="themeClass"></bar-rating>
            <p class="rating-label">Delivery</p>
        </div>

        <div class="feedback-comment-section">
            <p class="textarea-heading">{{ reviewHeadingTitle }}</p>
            <div class="textarea-content">
                <textarea
                    name="food-review"
                    placeholder="{{ placeholder }}"
                    [(ngModel)]="feedbackFormData.food_review"
                    maxlength="1024"></textarea>
                <div class="image-upload">
                    <div style="display: flex" #imagePreview></div>
                    @if (numberOfImages < maxImageToUpload) {
                        <div>
                            <label for="file-upload" style="cursor: pointer">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9 13L12 9L15 13.5V12H19V5C19 3.897 18.103 3 17 3H4C2.897 3 2 3.897 2 5V17C2 18.103 2.897 19 4 19H12V15H5L8 11L9 13Z"
                                        fill="#AAAAAA" />
                                    <path d="M19 14H17V17H14V19H17V22H19V19H22V17H19V14Z" fill="#AAAAAA" />
                                </svg>
                            </label>
                            <input
                                id="file-upload"
                                type="file"
                                accept="image/png,image/jpeg"
                                (change)="selectImage($event.target)"
                                (click)="$event.target.value = null" />
                        </div>
                    }
                </div>
            </div>
        </div>

        @if (showFoodRatingError) {
            <span class="error-text">Please rate to proceed!</span>
        }
        <button btn-primary size="full" (click)="checkFeedback()" [isLoading]="submitFeedbackInProgress">Submit Feedback</button>
    </form>
</div>

<div #loader style="display: none">
    <div class="loader" id="loader">
        <mat-spinner class="red-spinner"></mat-spinner>
    </div>
</div>
